import { render, staticRenderFns } from "./FakturPajakVendorUpload.vue?vue&type=template&id=2963918b&scoped=true"
import script from "./FakturPajakVendorUpload.vue?vue&type=script&lang=js"
export * from "./FakturPajakVendorUpload.vue?vue&type=script&lang=js"
import style0 from "./FakturPajakVendorUpload.vue?vue&type=style&index=0&id=2963918b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2963918b",
  null
  
)

export default component.exports